// OneDriveTutorial.tsx - Microsoft OneDrive OAuth Tutorial
// Spec 14: Multi-Cloud Integration

import { ChevronDown, ChevronUp, ExternalLink } from 'lucide-react'
import { useState } from 'react'

const FAQ_ITEMS = [
  { question: 'OAuth token nasil alinir?', answer: 'Azure Portal > App Registrations > New Registration > OAuth 2.0 flow ile token alin.' },
  { question: 'Hangi izinler gerekli?', answer: 'Files.ReadWrite.All izni yeterli.' },
  { question: 'Office 365 hesabi gerekli mi?', answer: 'Hayir, ucretsiz Microsoft hesabi yeterli (5GB).' }
]

export default function OneDriveTutorial() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <div className="min-h-screen" style={{ background: 'var(--body-bg)', padding: '20px' }}>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>OneDrive OAuth Token Nasil Alinir?</h1>
        <p className="mb-8" style={{ color: 'var(--text-secondary)' }}>Adim adim rehber</p>

        <div className="space-y-6 mb-8">
          <div className="card p-6 rounded" style={{ background: 'var(--card-bg)' }}>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-bold" style={{ background: 'var(--primary-color)', color: 'white' }}>1</div>
              <div className="flex-1">
                <h3 className="font-bold mb-2" style={{ color: 'var(--text-primary)' }}>Azure Portal&apos;a gidin</h3>
                <p style={{ color: 'var(--text-secondary)' }}><a href="https://portal.azure.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1" style={{ color: 'var(--primary-color)' }}>portal.azure.com <ExternalLink size={14} /></a></p>
              </div>
            </div>
          </div>

          <div className="card p-6 rounded" style={{ background: 'var(--card-bg)' }}>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-bold" style={{ background: 'var(--primary-color)', color: 'white' }}>2</div>
              <div className="flex-1">
                <h3 className="font-bold mb-2" style={{ color: 'var(--text-primary)' }}>App Registration olusturun</h3>
                <p style={{ color: 'var(--text-secondary)' }}>Azure Active Directory &gt; App Registrations &gt; New Registration</p>
              </div>
            </div>
          </div>

          <div className="card p-6 rounded" style={{ background: 'var(--card-bg)' }}>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-bold" style={{ background: 'var(--primary-color)', color: 'white' }}>3</div>
              <div className="flex-1">
                <h3 className="font-bold mb-2" style={{ color: 'var(--text-primary)' }}>OAuth Token alin</h3>
                <p style={{ color: 'var(--text-secondary)' }}>Microsoft Graph API OAuth flow ile access token alin.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="card p-6 rounded" style={{ background: 'var(--card-bg)' }}>
          <h3 className="text-xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>SSS</h3>
          <div className="space-y-2">
            {FAQ_ITEMS.map((item, index) => (
              <div key={index} className="rounded overflow-hidden" style={{ border: '1px solid var(--border-color)' }}>
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left" style={{ background: 'var(--secondary-bg)' }}>
                  <span className="font-semibold" style={{ color: 'var(--text-primary)' }}>{item.question}</span>
                  {openIndex === index ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </button>
                {openIndex === index && <div className="p-4" style={{ background: 'var(--card-bg)' }}><p style={{ color: 'var(--text-secondary)' }}>{item.answer}</p></div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
